import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TtBadge } from '@23/ui-react'

import { type FocusPane } from '../../../blocs/useFocusMode'
import type { FocusConfiguration } from '../FocusConfigurator'

import { FocusPreviewTrayMixOutput } from './FocusPreviewTrayMixOutput/FocusPreviewTrayMixOutput'
import { FocusPreviewTrayNotes } from './FocusPreviewTrayNotes/FocusPreviewTrayNotes'
import { FocusPreviewTrayQuestions } from './FocusPreviewTrayQuestions/FocusPreviewTrayQuestions'
import { FocusPreviewTrayScreenshare } from './FocusPreviewTrayScreenshare/FocusPreviewTrayScreenshare'
import { FocusPreviewTraySlides } from './FocusPreviewTraySlides/FocusPreviewTraySlides'
import { FocusPreviewTraySpeakers } from './FocusPreviewTraySpeakers/FocusPreviewTraySpeakers'

import './FocusPreview.scss'

interface FocusPreviewPaneProps {
  mode: FocusPane['mode']
  // speakerCount: number
  // screenCount: number
}

const FocusPreviewPane = ({ mode }: FocusPreviewPaneProps) => {
  switch (mode) {
    case 'tray-slides':
      return <FocusPreviewTraySlides />
    case 'tray-notes':
      return <FocusPreviewTrayNotes />
    case 'stage':
      return <FocusPreviewTrayMixOutput />
    case 'screens':
      return <FocusPreviewTrayScreenshare />
    case 'participants':
      return <FocusPreviewTraySpeakers />
    case 'chat':
    case 'questions':
      return <FocusPreviewTrayQuestions />
    default:
      return null
  }
}

interface FocusPreviewProps {
  configuration: FocusConfiguration
}

const FocusPreview = ({ configuration }: FocusPreviewProps) => {
  return (
    <div className="focus-configurator-preview">
      {configuration.leftPanelMode !== 'empty' && (
        <div className="focus-configurator-preview-left">
          <FocusPreviewPane mode={configuration.leftPanelMode} />
        </div>
      )}
      {configuration.rightPanelMode !== 'empty' && (
        <div className="focus-configurator-preview-right">
          <FocusPreviewPane mode={configuration.rightPanelMode} />
        </div>
      )}
      <div className="focus-configurator-preview-bottom">
        {configuration.liveTimer && (
          <div>
            <TtBadge>
              <FormattedMessage defaultMessage="Time live" />
            </TtBadge>
          </div>
        )}
        {configuration.timer && (
          <div>
            <TtBadge>
              <FormattedMessage defaultMessage="Timer" />
            </TtBadge>
          </div>
        )}

        {configuration.clock && (
          <div>
            <TtBadge>
              <FormattedMessage defaultMessage="Clock" />
            </TtBadge>
          </div>
        )}

        {configuration.stopwatch && (
          <div>
            <TtBadge>
              <FormattedMessage defaultMessage="Stopwatch" />
            </TtBadge>
          </div>
        )}

        {configuration.audienceCount && (
          <div>
            <TtBadge>
              <FormattedMessage defaultMessage="Participants" />
            </TtBadge>
          </div>
        )}

        {configuration.reactions && (
          <div>
            <TtBadge>
              <FormattedMessage defaultMessage="Reactions" />
            </TtBadge>
          </div>
        )}
      </div>
    </div>
  )
}

export { FocusPreview }
